export const merchantsData = [
  {
    path: "/apply/merchants/12/shopsManage",
    name: "商户管理"
  },
  {
    path: "/apply/merchants/12/shopsSetting",
    name: "店铺设置"
  },
  {
    path: "/apply/merchants/12/shopsCommodity",
    name: "商户商品"
  },
  {
    path: "/apply/merchants/12/shopsOrder",
    name: "商户订单"
  },
  {
    path: "/apply/merchants/12/shopsAccount",
    name: "商户结算"
  },
  {
    path: "/apply/merchants/12/shopsServe",
    name: "商户服务"
  }
];
